import Vue from "vue"
import * as Sentry from "@sentry/browser"
import { Vue as VueIntegration } from "@sentry/integrations"
import AsyncComputed from "vue-async-computed"

import themeKit from "@/plugins/theme-kit"

import App from "./App.vue"
import router from "./router"
import store from "./store"
import { createProvider } from "./vue-apollo"
import Dialog from "vue-dialog-loading"
import Toasted from "vue-toasted"

import VueTagsInput from "@johmun/vue-tags-input"
import VueLodash from "vue-lodash"
import lodash from "lodash"

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"
import Utils from "@/utils"
import VueMoment from "vue-moment"
import ECharts from "vue-echarts"

import "echarts/lib/chart/pie"
import "echarts/lib/component/tooltip"
import "echarts/lib/component/legend"
import "zrender/lib/svg/svg"

import {
  faChartLine,
  faHandPeace,
  faCode,
  faTicketAlt
} from "@fortawesome/free-solid-svg-icons"

import VCalendar from "v-calendar"
import VueLazyload from "vue-lazyload"
//Layouts
import Default from "@/components/layouts/default"
import Authentication from "@/components/layouts/authentication"

Vue.component("default-layout", Default)
Vue.component("authentication-layout", Authentication)
if (process.env.NODE_ENV != "development")
  Sentry.init({
    dsn: "https://8aa0a9596b354dc68f2663cd8bf0ca2c@sentry.ncms.co.za/15",
    integrations: [
      new VueIntegration({
        Vue,
        attachProps: true,
        tracingOptions: {
          trackComponents: true
        }
      })
    ]
  })

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("./firebase-messaging-sw.js")
    .then(function(registration) {
      console.log("Registration successful, scope is:", registration.scope)
    })
    .catch(function(err) {
      console.log("Service worker registration failed, error:", err)
    })
}
const options = {
  theme: "bubble",
  position: "top-left",
  duration: 5000
}

Vue.use(Toasted, options)
Vue.component("loading", () => import("@/components/loading"))
Vue.use(AsyncComputed)
Vue.use(themeKit)
Vue.use(Dialog)
Vue.use(VueLodash, { lodash: lodash })
Vue.component("v-chart", ECharts)
Vue.prototype.$utils = Utils
Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.use(VCalendar)
library.add(faChartLine, faHandPeace, faCode, faTicketAlt)
Vue.use(VueLazyload)
Vue.use(VueTagsInput)
Vue.use(VueMoment)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount("#app")
